<div class="bg_message"></div>
<div class="bottom_message" id="message_form">
  <div class="wrap">
    <div class="ttl">{{ header }}</div>
    <div class="message">
      <div class="txt" [innerHTML]="text"></div>
    </div>
    <a class="close close_modal_ref" (click)="activeModal.close()"></a>
  </div>
</div>
